module.exports = __webpack_public_path__ + "static/media/409.054486d9.png";